import styled from 'styled-components'
import PreviewSliderSection from 'Components/PreviewSliderSection'


export const _SimilarContainer = styled.div`
  min-width: 100%;
`

export const _SliderSection = styled(PreviewSliderSection)`
  .swiper-slide{
    max-width: 270px;
  }
`
